module.exports = __webpack_public_path__ + "assets/images/50HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50HL.png
// module id = 1303
// module chunks = 1